import React, { useEffect, useState } from 'react';
import { FaApple, FaGooglePlay, FaTimes } from 'react-icons/fa';
import { isMobile, isBrowser } from 'react-device-detect';
import { useRouter } from 'next/router';
import { Capacitor } from '@capacitor/core';

// Link to downlaod the app from the App Store and Google Play
const AppDownloadLinks = () => {
  if (!isBrowser) return null; // Only render if on a browser

  return (
    <div className="app-download-links">
      <div>
      <a href="https://apps.apple.com/ca/app/sunulife/id6744858761" target="_blank" rel="noopener noreferrer" className="app-link">
        <FaApple /> App Store
      </a>
      </div>
      <div>
      <a href="https://play.google.com/store/apps/details?id=com.sunulife.twa" target="_blank" rel="noopener noreferrer" className="app-link">
        <FaGooglePlay /> Google Play
      </a>
      </div>
    </div>
  );
};


const AppDownloadBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (isMobileBrowser()) {
      const dismissedTime = localStorage.getItem('bannerDismissedTime');
      const currentTime = new Date().getTime();

      if (!dismissedTime || currentTime - dismissedTime > (3600000 * 12)) { // Show after 24 hour if previously dismissed
        setTimeout(() => {
          setIsVisible(true);
        }, 1000); // Slide in after 3 seconds
      }
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('bannerDismissedTime', new Date().getTime());
  };

  function isAppUserAgent() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Check for iOS and Android bundle identifiers or Capacitor-specific indicators in the user agent
    return userAgent.includes("raQtaQ_APP") || // Custom identifier for Capacitor app
           userAgent.includes("Capacitor") ||
           userAgent.includes("com.looybi.app") || // iOS bundle identifier
           userAgent.includes("com.raqtaq.twa");   // Android bundle identifier
  }

  function isRunningInApp() {
    return Capacitor.isNativePlatform(); // Detect if running in a native Capacitor platform
  }

  function isPWA() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  }

  function isMobileBrowser() {
    return isMobile && !isAppUserAgent() && !isRunningInApp() && !isPWA();
  }

  const bannerText = () => {
    const activePath = router.asPath;
    if (activePath.startsWith(`/fr`)) {
      return `Installez l'application Sunulife et amplifions la Sénégambie !`;
    } else {
      return `Install the Sunulife App and amplify Senegambia!`;
    }
  };

  if (!isVisible) return null; // Only render if the banner should be visible

  return (
    <div className="app-prompt-banner slide-in" style={{ bottom: '100px', margin: '0 20px', position: 'fixed', left: '20px', right: '20px' }}>
      <div className="dismiss-button" onClick={handleDismiss}>
        <FaTimes />
      </div>
      <p>{bannerText()}</p>
      <div className="app-download-links">
        <div>
          <a href="https://apps.apple.com/ca/app/sunulife/id6744858761" target="_blank" rel="noopener noreferrer" className="app-link">
            <FaApple /> App Store
          </a>
        </div>
        <div>
          <a href="https://play.google.com/store/apps/details?id=com.sunulife.twa" target="_blank" rel="noopener noreferrer" className="app-link">
            <FaGooglePlay /> Google Play
          </a>
        </div>
      </div>
    </div>
  );
};


export { AppDownloadLinks, AppDownloadBanner };